import React from "react";
import ReactPlayer from "react-player";
import styles from "./VideoPlayer.module.scss";

type Props = {
  videoUrl: string;
  stopAutoplay?: boolean;
  poster?: string;
  controls?: boolean;
};

const Video = (props: Props) => {
  return (
    <ReactPlayer
      className={styles.VideoPlayer__video_player}
      url={props.videoUrl}
      config={{
        youtube: {
          playerVars: { modesbranding: 1 },
        },
        file: {
          forceHLS: true,
        },
      }}
      width="100%"
      height="100%"
      playing={!props.stopAutoplay}
      light={props.poster}
      controls={props.controls}
    />
  );
};

export default Video;
